module.exports = __webpack_public_path__ + "static/media/12591.51eca0a9.jpg";